import { useTranslation } from 'react-i18next'
import type { CommandListResponse } from '@/entities/command'
import { StatusBadge } from '@/shared/ui/StatusBadge'

type ExchangeChipProps = {
  exchange: CommandListResponse['summary']['exchange']
}

/** Связь с 1С глазами бэка: чип в подвале модалки. Нет данных — чипа нет, а не «на связи». */
export function ExchangeChip({ exchange }: ExchangeChipProps) {
  const { t } = useTranslation('processes')

  return (
    <StatusBadge tone={exchange === 'online' ? 'success' : 'danger'} size="sm" indicator="dot">
      {t(`exchange.${exchange}`)}
    </StatusBadge>
  )
}
